import { TranslationInfo } from "@shared/types/translation-info";

export const DAYS: readonly TranslationInfo[] = [
  {
    defaultText: "Montag",
    token: "day-of-week-0",
    scope: "global"
  },
  {
    defaultText: "Dienstag",
    token: "day-of-week-1",
    scope: "global"
  },
  {
    defaultText: "Mittwoch",
    token: "day-of-week-2",
    scope: "global"
  },
  {
    defaultText: "Donnerstag",
    token: "day-of-week-3",
    scope: "global"
  },
  {
    defaultText: "Freitag",
    token: "day-of-week-4",
    scope: "global"
  },
  {
    defaultText: "Samstag",
    token: "day-of-week-5",
    scope: "global"
  },
  {
    defaultText: "Sonntag",
    token: "day-of-week-6",
    scope: "global"
  }
];
